import { useNavigate } from 'react-router-dom';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { brandsTranslations } from '@pages/Brands/translations';
import { Button } from '@components/Core/Button';
import AddIcon from '@icons/add_circle_icon.svg?component';
import { BrandsTransFields } from '@pages/Brands/types';
import { HomeTransFields } from './types';
import { homeTranslations } from './translations';

function Home() {
  const { t } = useMyTranslations<HomeTransFields | Extract<BrandsTransFields, 'addBrand'>>([
    homeTranslations.name,
    brandsTranslations.name,
  ]);
  const navigate = useNavigate();

  return (
    <div className="page-container flex flex-col justify-center items-center gap-y-[12px]">
      <div className="flex-centred bg-container-bg w-[96px] h-[96px] rounded-full">
        <AddIcon width={48} height={48} />
      </div>
      <p className="page-title-text !leading-[24px]">{t('title')}</p>
      <p className="small-text">{t('description')}</p>
      <Button
        text={t('addBrand', { ns: brandsTranslations.name })}
        onClick={() => navigate('/add-brand')}
        styleProp="!w-[153px]"
      />
    </div>
  );
}

export default Home;
